import { ICardDetails, ICardSession, ITokenizeCardRequest } from 'types';
import { appConfig } from '../config/app';
import { ApiClient } from './ApiClient';

export const Cards = {
  getCardSession: (hostUri: string) => ApiClient.get<ICardSession>(`${appConfig.API_BASE_URL}/v1/plugin/session?host_uri=${hostUri}`),
  tokenizeCard: (options: ITokenizeCardRequest) => ApiClient.post<ICardDetails>(`${appConfig.API_BASE_URL}/v1/cards`, options),
  getCard: (cardId: string) => ApiClient.get<ICardDetails>(`${appConfig.API_BASE_URL}/v1/cards/${cardId}`),
  deleteCard: (cardId: string) => ApiClient.delete<ICardDetails>(`${appConfig.API_BASE_URL}/v1/cards/${cardId}`),
};
